import { useMemo } from 'react';
import { JurisdictionsEnum } from '@libs/backend-common';
import { getJurisdictionBaseUrl } from '@libs/helpers';
import { BrandName } from './constants';
export const useJurisdictionDetector = (env, jurisdictionId) => {
    const currentJurisdiction = useMemo(() => {
        if (jurisdictionId) {
            return jurisdictionId;
        }
        else {
            const { jurisdictionId } = getJurisdictionBaseUrl(env);
            if (jurisdictionId) {
                return jurisdictionId;
            }
            return JurisdictionsEnum.GE;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [jurisdictionId]);
    return {
        brandName: BrandName[currentJurisdiction],
        currentJurisdiction,
        jurisdictionId,
    };
};
//# sourceMappingURL=useJurisdictionDetector.js.map